// @ts-nocheck


import React from 'react'
import card1 from '../../../../../../public/assets/img/WomansCategory/1.png'
import card2 from '../../../../../../public/assets/img/WomansCategory/2.png'
import card3 from '../../../../../../public/assets/img/WomansCategory/3.png'
import { guestAccountDetailSlice } from 'src/store/slices/guestAccountDetailSlice'
import { useAppDispatch } from 'src/store/store'
import { useAuth } from 'src/utils/auth'
import Slider from "react-slick";

import Slidercard1 from '../../../../../../public/assets/fashion/women/fashionbannersliderimage1.png'
import Slidercard2 from '../../../../../../public/assets/fashion/women/fashionbannersliderimage2.png'
import Slidercard3 from '../../../../../../public/assets/fashion/women/fashionbannersliderimage3.png'
import { useRouter } from 'next/router'

export default function ShopCardSection() {
  const dispatch = useAppDispatch()
  const { user }: any = useAuth()
    const router = useRouter()
  

  const settings = {
    dots: false,
    // infinite: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
    centerPadding: "26px",
    className: "center",
    arrows: false,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          centerMode: false,
          variableWidth: true,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          infinite: true,
          centerMode: false,
          variableWidth: true,
        }
      }
    ]
  };

  return (
    <section className="section_2">
      {/* <div className="container">
        <div className="row section_2_row">
          <div className="col_img col_1" onClick={handleRedirect}>
            <div className="img_cover">
              <img src={card1.src} alt="img_cover" />
            </div>
          </div>
          <div className="col_img col_2" onClick={handleRedirect}>
            <div className="img_cover">
              <img src={card2.src} alt="img_cover" />
            </div>
          </div>
          <div className="col_img col_3" onClick={handleRedirect}>
            <div className="img_cover">
              <img src={card3.src} alt="img_cover" />
            </div>
          </div>
        </div>
      </div> */}
      <div className="section_2_slider_main_web">
        <div className="container">
          <div className='section_2_slider'>
            <div className="section_2_slider_content" onClick={() => { router.push('/store/mkfcollection') }}>
              <img src={Slidercard1.src} alt="img_cover" />
            </div>
            <div className="section_2_slider_content" onClick={() => { router.push('/search/?q=summer%20dress&type=product') }}>
              <img src={Slidercard2.src} alt="img_cover" />
            </div>
            <div className="section_2_slider_content" onClick={() => { router.push('/store/adinaeden') }}>
              <img src={Slidercard3.src} alt="img_cover" />
            </div>
          </div>
        </div>
      </div>
      <div className="section_2_slider_main_mobile">
        {/* <div className="container"> */}
        <Slider {...settings}>
          <div>
            <div className="section_2_slider_content" onClick={() => { router.push('/store/mkfcollection') }}>
              <img src={Slidercard1.src} alt="img_cover" />
            </div>
          </div>
          <div>
            <div className="section_2_slider_content" onClick={() => { router.push('/search/?q=summer%20dress&type=product') }}>
              <img src={Slidercard2.src} alt="img_cover" />
            </div>
          </div>
          <div>
            <div className="section_2_slider_content" onClick={() => { router.push('/store/adinaeden') }}>
              <img src={Slidercard3.src} alt="img_cover" />
            </div>
          </div>
        </Slider>
        {/* </div> */}
      </div>
    </section>
  )
}
